























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'OrderbookToolbar',
})
export default class OrderbookToolbar extends Vue {
  @Prop(Boolean) public loaded!: boolean;
  @Prop(Array) public factorList!: number[];
  @Prop(String) public borderLeftColor!: string;
  @Prop(Function) public setFactor!: (factor: number) => void;
}
